var React = require('react');

function Admin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1280 512q0 106-40 199t-109 163-163 110-200 40q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-121 35-232t100-204 156-166 204-116q-56-36-100-83t-75-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200zM768 896q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30zm1280 163v325q0 105-38 198t-101 173-145 144-169 110l-59 31-60-31q-87-45-168-109t-145-145-101-173-38-198v-325q35 0 75 1t81-1 79-10 71-28q50-29 99-42t107-14q59 0 108 14t100 43q31 18 69 26t79 11 81 1 75-1zm-128 325v-197q-66 0-127-12t-118-45q-34-20-66-28t-73-9q-38 0-71 8t-66 28q-58 33-119 45t-128 13v197q0 86 33 162t88 142 123 118 140 90q70-37 139-89t123-118 88-142 34-163z"}));
}

Admin.defaultProps = {"viewBox":"0 0 2048 2048","width":"32","height":"32"};

module.exports = Admin;

Admin.default = Admin;
